export default {
    'INSERIR_TIPORESIDENCIA' (state, payload) {
     state.tipos = payload;
    }
}